// @flow @format
import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LoginPage from './pages/Login';

const routes = () => ({
	path: 'login',
	components: {
		header: () => <Header />,
		footer: () => <Footer />,
		main: LoginPage,
	},
});

export default routes;



// WEBPACK FOOTER //
// ./src/routes/Login/index.js